import PropTypes from 'prop-types';
import styled from 'styled-components';

const BoxSizing = styled.div.attrs(props => ({ 'data-qa': props.qa }))`
  * {
    box-sizing: ${props => props.type}-box;
  }
`;

BoxSizing.propTypes = {
  type: PropTypes.oneOf(['border', 'content']),
  qa: PropTypes.string
};

BoxSizing.defaultProps = {
  type: 'border',
  qa: undefined
};

/** @component */
export default BoxSizing;
